import React from 'react';

const DiscardUnsavedChangesModal = ({ isOpen, onKeepEditing, onDiscard }) => {
  if (!isOpen) return null;

  return (
    <div className="stm-discard-overlay" onClick={onKeepEditing}>
      <div className="stm-discard-modal" onClick={(event) => event.stopPropagation()}>
        <h3>Discard unsaved changes?</h3>
        <p>Your changes haven&apos;t been saved.</p>
        <div className="stm-discard-modal__actions">
          <button type="button" className="stm-btn stm-btn--primary" onClick={onKeepEditing}>
            Keep Editing
          </button>
          <button type="button" className="stm-btn stm-btn--secondary" onClick={onDiscard}>
            Discard
          </button>
        </div>
      </div>
    </div>
  );
};

export default DiscardUnsavedChangesModal;
